module.exports = __webpack_public_path__ + "static/img/carousel@2x.159f3ba8.png";